module.exports = __webpack_public_path__ + "img/target.9e93634a.svg";